import Button from 'react-bootstrap/Button';
import './index.css';

const GroupButton = ({leftButton, rightButton}) => {
  return (
    <div className='group_button pt-3'>
      <Button className='left_button' onClick={leftButton.onClick} disabled={leftButton.disabled}>{leftButton.content}</Button>
      <Button className='right_button' onClick={rightButton.onClick} disabled={rightButton.disabled}>{rightButton.content}</Button>
    </div>
  );
}

export default GroupButton;